import { render, staticRenderFns } from "./SequenceQuestion.vue?vue&type=template&id=74498b46&"
import script from "./SequenceQuestion.vue?vue&type=script&lang=js&"
export * from "./SequenceQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports